const customDate = (fullDate) => {
  if (!fullDate) return ["", ""];
  const [date] = fullDate.split("T");
  const [yy, mm, dd] = date.split("-");

  return [`${dd}-${mm}-${yy}`, `${yy}-${mm}-${dd}`];
};

export default customDate;
